import { render, staticRenderFns } from "./CompoundStatusBadge.vue?vue&type=template&id=fa6a8f44&scoped=true&"
import script from "./CompoundStatusBadge.vue?vue&type=script&lang=js&"
export * from "./CompoundStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./CompoundStatusBadge.vue?vue&type=style&index=0&id=fa6a8f44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6a8f44",
  null
  
)

export default component.exports